import React, { useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Button, Container, Media } from 'reactstrap';

import withRedirect from '../../helpers/hoc/withRedirect';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import settings from './../../assets/img/illustrations/settings.png';

const PropertyStatusCondominium = () => {

    const { updated, firstname } = useSelector(state => state.auth.user);

    const UpdateDataAlertModal = (props) => {

        const { className } = props;
        const [modal, setModal] = useState(!updated && sessionStorage.getItem('lose') === 'true');
        const toggle = () => { sessionStorage.setItem('lose', false); setModal(!modal); };
        
        return <>
            <Modal isOpen={modal} toggle={toggle} className={className}>
                <ModalHeader toggle={toggle}>Actualiza tus datos!</ModalHeader>
                <ModalBody>
                    <Container>
                        <Row className='justify-content-center py-2'>
                            <Media className='w-50' src={settings} />
                        </Row>
                        <Row className='px-2'>
                            <p >
                                Recuerda <strong>actualizar tus datos personales</strong>,
                                asi podemos brindarte un mejor servicio,
                                para hacerlo has <strong>click</strong> en
                                <strong><Link className='ml-1' to={'#'}>Actualizar datos de mi cuenta</Link></strong>
                            </p>

                            <h5 className='mb-2'>
                                <FontAwesomeIcon icon={faExclamationCircle} className="mr-2" />
                                Recuerda, estar actualizado nos ayuda a:
                            </h5>
                            <ul>
                                <li>Asegurar tu cuenta actualizando la contraseña.</li>
                                <li>Mantener la base de datos actualizada.</li>
                                <li>Facilita el contacto con el cliente.</li>
                                <li>Además que mejorará la atención al cliente que podemos ofrecerte.</li>
                            </ul>
                        </Row>
                    </Container>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>Lo haré luego</Button>
                </ModalFooter>
            </Modal>
        </>
    }

    return  <>
                <header className="hl-page-header hl-page-header--greeting">
                    <h1 className="hl-page-header__title">{firstname ? `Hola, ${firstname}` : "Hola"}</h1>
                    {!updated && <p className="hl-page-header__description mb-0">
                        Aún no has actualizado tus datos.
                        <Link className='ml-1' to={'/dashboard/my/profile'}>Actualizar datos de mi cuenta</Link>
                    </p>}
                </header>
                <UpdateDataAlertModal />
            </>
}

export default withRedirect(PropertyStatusCondominium);